var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 51.1 50"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M47.1 20H40a20.05 20.05 0 1 0-9.9 17.24V46a4 4 0 0 0 4 4h13a4 4 0 0 0 4-4V24a4 4 0 0 0-4-4m-17 4v10.89A18 18 0 1 1 38 20h-3.9a4 4 0 0 0-4 4m19 22a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2v-5.53h17Zm-17-22a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v14.47h-17Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 40.6,
  cy: 44.07,
  r: 1.5,
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m18.86 23.18-4.67-6.02-1.58 1.22 6.19 7.99 8.92-10.66-1.53-1.28z"
})));
export default SvgCheckPhone;